import {Base,Axios} from "@/api/Base"

export class LeaveDownloadLeaveReport extends Base {
    path = "leave/downLeaveReport"
    download(param = {}) {
        return Axios.get(this.path, { params: param,responseType: "blob" })
    }
}